// Import Swiper and modules
import Swiper, { Navigation, Pagination, Thumbs, FreeMode } from 'swiper';

function swipe_anchor(){
    let swipe = new Swiper('.block.anchors .anchors__content', {
        slidesPerView : 'auto',
        spaceBetween: 30
    });

}
swipe_anchor();

//Swiper Gallery
function swipe_gallery() {
    const swipe = new Swiper('.slider-gallery .swiper', {
        modules: [ Navigation, Pagination ],
        loop: false,
        slidesPerView : 1,
        spaceBetween: 30,
        pagination: {
            el: '.slider-gallery .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.slider-gallery .swiper-button-next',
            prevEl: '.slider-gallery .swiper-button-prev',
        },
        breakpoints: {
            768: {
                slidesPerView: 2.5,
                loop: true
            },
        }
    });
}
swipe_gallery();

//Swiper testimonials
function swipe_testimonials(){

    const f = {
        playVideo:function(){
            let button = document.querySelectorAll('.slider-testimonials .swiper-slide button');
            button.forEach(function(item) {
                item.addEventListener('click', function(){
                    let videos = document.querySelectorAll('.slider-testimonials .swiper-slide video');
                    videos.forEach(function(item) {
                        item.pause();
                        item.removeAttribute('controls');
                        let slide = item.closest('.swiper-slide');
                        slide.classList.remove('play');
                    });
                    let slide = this.closest('.swiper-slide');
                    let video = this.closest('.swiper-slide').querySelector('video');
                    video.play();
                    video.setAttribute('controls',true);
                    slide.classList.add('play');
                })
            })
        }
    };


    let swipe1Count = document.querySelectorAll('.slider-testimonials .swiper .swiper-slide').length;
    let swipe = null;
    swipe = new Swiper('.slider-testimonials .swiper', {
        modules: [ Navigation, Pagination ],
        loop: false,
        slidesPerView : 1,
        pagination: {
            el: '.slider-testimonials .swiper-pagination',
            type: 'bullets',
            clickable: true
        },
        navigation: {
            nextEl: '.slider-testimonials .swiper-button-next',
            prevEl: '.slider-testimonials .swiper-button-prev',
        },
    });
    swipe.on('slideChange', function () {
        let index = swipe.activeIndex;
        document.querySelectorAll('.slider-testimonials .item.active')[0].classList.remove('active');
        document.querySelectorAll('.slider-testimonials .items .item')[ (index)].classList.add('active');

        document.querySelectorAll('.slider-testimonials .images .image.active')[0].classList.remove('active');
        document.querySelectorAll('.slider-testimonials .images .image')[ (index)].classList.add('active');

        let videos = document.querySelectorAll('.slider-testimonials .swiper-slide video');
        videos.forEach(function(item) {
            item.pause();
            item.removeAttribute('controls');
            let slide = item.closest('.swiper-slide');
            slide.classList.remove('play');
        });

    });

    // f.playVideo();
}
swipe_testimonials();

// Swiper interactive map 4
function swipe_interactivemap4(){
    const swipe = new Swiper('.block.interactive-map4 .swiper-map',{
        spaceBetween: 15,
        breakpoints: {
            768: {
                spaceBetween: 0
            },
        }
        // on: {
        //     afterInit: function () {
        //             let h = document.querySelector('.block.interactive-map4 .swiper-map').offsetHeight + 10;
        //             document.querySelector(".block.interactive-map4 .point").style.bottom = h + 'px';
        //     },
        // }
    });
    const pins = document.querySelectorAll('.block.interactive-map4 [data-pin]');

    swipe.on('slideChange', function (){
        let index = swipe.activeIndex;
        for (let i = 0; i < pins.length; ++i) {
            pins[i].classList.add('disabled');
        }
        document.querySelector('.block.interactive-map4 [data-pin="'+index+'"]').classList.remove('disabled');
    });

    for (let i = 0; i < pins.length; ++i) {
        pins[i].addEventListener('click', function () {
            let pin = this.getAttribute('data-pin');
            swipe.slideTo(pin);
            document.querySelector(".block.interactive-map4 .point span").innerText = parseInt(pin) + 1;
        })
    }
}
swipe_interactivemap4();

// Swiper multimedia
function swipe_multimeda(){

    let elemt = document.querySelectorAll('.block.multimedia');
    elemt.forEach(function(item, index){
        let m = item.querySelectorAll('.multimedia__item');
        let s = item.querySelectorAll('.sliders');
        m.forEach(function(o){
            o.addEventListener('click', function(){
                let controls = this.getAttribute('aria-controls');
                m.forEach(function (c) {
                    c.classList.remove('active');
                });
                s.forEach(function (c) {
                    c.classList.add('d-none');
                });
                this.classList.add('active');
                document.getElementById(controls).classList.remove('d-none');
            })
        });
    });


    let sliders = document.querySelectorAll('.block.multimedia .sliders');
    if( !sliders ){
        return;
    }
    sliders.forEach(function(item, index) {
        let id = item.id;


        let sb = item.querySelector('.slider__bottom');
        let st = item.querySelector('.slider__top');

        if( sb.length == 0 && st.length == 0){
            return;
        }

        // slider thumbnail
        let swipe2 = new Swiper('#'+id+ ' .slider__bottom', {
            modules: [ Navigation, Pagination, FreeMode ],
            loop: false,
            spaceBetween: 8,
            slidesPerView: 9,
            freeMode: true,
            watchSlidesProgress: true,
            navigation: {
                nextEl: '#'+item.id+' .slider__bottom_container .swiper-button-next',
                prevEl: '#'+item.id+'.slider__bottom_container .swiper-button-prev',
            }
        });
        // slider principal
        let swipe1 = new Swiper('#'+id+ ' .slider__top', {
            modules: [ Navigation, Pagination, Thumbs, FreeMode ],
            loop: true,
            spaceBetween: 30,
            pagination: {
                el: '#'+item.id+' .slider__top_container .swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            navigation: {
                nextEl: '#'+item.id+' .slider__top_container .swiper-button-next',
                prevEl: '#'+item.id+' .slider__top_container .swiper-button-prev',
            },
            thumbs: {
                swiper: swipe2
            },
            breakpoints: {
                768: {
                    spaceBetween: 10
                }
            }
        });

    });


    let m2 = document.querySelectorAll('.multimedia__item');
    m2.forEach(function (item, index) {
        item.addEventListener('click', function () {
            let e = this.closest('.multimedia__items');
            if( e.classList.contains('open') ){
                this.closest('.multimedia__items').classList.remove('open');
            } else {
                this.closest('.multimedia__items').classList.add('open');
            }
        })
    })

}
swipe_multimeda();
